export default __webpack_public_path__ + "static/media/proc2-world.4d4384fb.jpg";